import { buildNeighborhoodOfficeSeo } from 'ux/Public/OfficeSeo/data/officeSeoNeighborhoodBuild';

export const nycFlatironNomadOfficeSeo = buildNeighborhoodOfficeSeo({
  cityPathSegment: 'new-york',
  neighborhoodSlug: 'flatiron---nomad',
  neighborhoodDisplayName: 'Flatiron / NoMad',
  metroDisplayName: 'New York',
  totalCodiClientsInNeighborhood: 28,
  nycLocalPreset: 'flatiron',
  whereFromStreetsToLandmark:
    'from the buildings along Broadway, E 24th St, and Madison Ave to the clusters near Flatiron Building',
  whereTeamStreets: 'Broadway, E 24th St, Madison Ave, W 21st St',
  clientDescriptor: 'around 30 people software startup near Madison Ave',
  clientEngagementByService: {
    officeAssistant: 'brought Codi in for daily office logistics \u2014 no full-time hire needed.'
  },
  counts: {
    managedCleaningOffices: 15,
    managedPantryOffices: 28,
    managedInternetOffices: 24,
    managedFurnitureOffices: 15,
    managedDeepCleaningOffices: 9,
    managedCarpetCleaningOffices: 7,
    managedWindowCleaningOffices: 6,
    managedGlassCleaningOffices: 11,
    managedWasteRecyclingOffices: 8,
    managedPantryInventoryOffices: 20,
    managedCoffeeServiceOffices: 15,
    managedWaterServiceOffices: 14,
    managedTeamLunchOffices: 8,
    managedBreakfastCateringOffices: 6,
    managedIndividualMealsOffices: 5,
    managedAdHocCateringOffices: 9,
    managedHappyHourOffices: 7,
    managedConferenceRoomAvOffices: 10,
    managedNetworkInstallationOffices: 19,
    managedNetworkManagementOffices: 13,
    managedCableManagementOffices: 8,
    managedRoomBookingOffices: 7,
    managedPrintingSetupOffices: 12,
    managedInteriorDesignOffices: 10,
    managedOfficeMuralsOffices: 4,
    managedOfficePaintingOffices: 6,
    managedGlassFrostingOffices: 8,
    managedOfficeSignageOffices: 5,
    managedCareRoomOffices: 4,
    managedFurnitureAssemblyOffices: 13,
    managedLayoutChangeOffices: 8,
    managedOfficePlantsOffices: 11,
    managedKeylessAccessOffices: 12,
    managedAlarmSystemsOffices: 7,
    managedSecurityCamerasOffices: 10,
    managedKeypadOffices: 9,
    managedLockboxOffices: 5,
    managedVisitorManagementOffices: 8,
    managedBusinessInsuranceOffices: 10,
    managedElectricalServicesOffices: 7,
    managedHvacOffices: 6,
    managedPlumbingOffices: 5,
    managedPestControlOffices: 5,
    managedOfficeMovingOffices: 7,
    managedMountingInstallationOffices: 9
  },
  quotes: {
    cleaning: "We didn't want to deal with elevator bookings and vendor coordination. Codi does it.",
    pantryRestocking: "Manhattan delivery windows are brutal. Codi figures it out so we don't have to.",
    internet: "Codi coordinated everything with the building ops team so we didn't have to.",
    officeAssistant:
      'We needed someone to handle our daily office logistics - someone who knows the building and the vendors.',
    officeFurniture:
      'Freight elevator booking for furniture deliveries is such a pain in these office buildings. Codi handled it end-to-end.',
    deepCleaning: 'Deep cleans in a Flatiron building require real coordination. Codi handled every piece of it.',
    carpetCleaning: 'COI requirements for carpet vendors in this building are intense. Codi sorted it out.',
    windowCleaning: 'High-floor window cleaning in Manhattan is not a DIY project. Codi manages the vendor.',
    glassConferenceRoom: 'Glass walls get marked up constantly. Codi keeps them spotless on a weekly schedule.',
    wasteRecycling: 'NYC waste rules are complicated. Codi manages compliant pickup without us having to think.',
    pantryInventory:
      'Flatiron office, fast-moving team \u2014 pantry stockouts were a constant problem. Codi automated it.',
    coffeeService: 'Quality coffee matters in a Flatiron office. Codi manages the machine, beans, and maintenance.',
    waterService: 'Filtered water is standard here. Codi handles the dispenser setup and restocking on schedule.',
    teamLunch: 'We do catered team lunches weekly. Codi handles the vendor coordination and delivery in Manhattan.',
    breakfastCatering: 'Weekly breakfast for the team. Codi sources locally and coordinates building delivery access.',
    individualMeals: 'Daily lunch delivery for the Flatiron team. Codi owns the vendor relationship and the logistics.',
    adHocCatering:
      'Board meetings, investor days, all-hands \u2014 Codi handles catering for every major Flatiron event.',
    happyHour: 'Happy hour in our Flatiron office is a weekly ritual. Codi handles the drinks order and the setup.',
    conferenceRoomAv:
      'Flatiron startup culture means every conference room needs great A/V. Codi made it happen across all four rooms.',
    networkInstallation:
      'Growing fast in Flatiron \u2014 needed a network that could scale. Codi designed and installed it properly from the start.',
    networkManagement: 'Codi manages our entire Flatiron network. Uptime has been flawless since they took over.',
    cableManagement:
      'Open-plan Flatiron office with cable chaos everywhere. Codi ran clean overhead trays and labeled every run.',
    roomBooking:
      'Flatiron office with six conference rooms always in use. Codi deployed room tablets and the double-booking problem ended.',
    printingSetup:
      'Multi-floor Flatiron office, four printers. Codi handled every delivery, install, and driver config in one day.',
    interiorDesign:
      'Flatiron office needed a redesign for hybrid work. Codi managed the space plan, vendor selection, and full build-out.',
    officeMurals:
      'We wanted the brand on the wall. Codi sourced a Flatiron-area muralist and coordinated building approval.',
    officePainting:
      'Office refresh before a new lease cycle. Codi ran the painters after-hours and had approvals handled in advance.',
    glassFrosting:
      'Privacy film across our glass-walled offices. Codi measured, ordered, and installed everything in one session.',
    officeSignage:
      'New Flatiron location needed a proper lobby presence. Codi designed, fabricated, and installed the full signage package.',
    careRoom:
      'Team asked for a designated care room. Codi sourced a privacy curtain, chair, and power outlet extension in one visit.',
    furnitureAssembly:
      'We expanded from two floors to three. Codi sent assembly crews and had the new floor operational in a day.',
    layoutChange:
      'Hybrid work meant reconfiguring from assigned to flexible seating. Codi managed the full reconfiguration over a weekend.',
    officePlants:
      'Flatiron office with exposed brick and great light. Codi curated a plant program that fits the aesthetic.',
    keylessAccess:
      'Flatiron building required keyless access registration before move-in. Codi handled all coordination, hardware, and credential setup.',
    alarmSystems:
      'Building management required a monitored alarm before occupancy. Codi sourced the vendor, handled COI, and manages ongoing testing.',
    securityCameras:
      'High-traffic Flatiron office needed camera coverage at all entry points. Codi installed and manages the system remotely.',
    keypads:
      'Multiple entry points in our Flatiron space. Codi installed keypads, manages codes, and handles all maintenance.',
    lockboxes:
      'After-hours vendor access in a Flatiron building requires building coordination. Codi manages all lockbox access.',
    visitorManagement:
      'Investor days and client visits are frequent in Flatiron. Codi deployed a visitor management system that handles check-in and compliance.',
    businessInsurance:
      'Flatiron lease required COI updates every quarter. Codi manages our business insurance and handles all certificate requests.',
    electricalServices:
      'Flatiron office needed additional circuits for server infrastructure. Codi coordinated a licensed master electrician and managed DOB permits.',
    hvac: 'HVAC issues in a shared Flatiron building require building engineering coordination. Codi manages our HVAC vendor and handles all scheduling.',
    plumbing:
      'Kitchen plumbing issue on a busy Friday. Codi had a licensed plumber there within hours and coordinated building access.',
    pestControl:
      'Manhattan buildings need proactive pest control. Codi schedules quarterly treatments and maintains all compliance documentation.',
    officeMoving:
      'Flatiron to Nomad office move with 60 employees. Codi managed freight elevator booking, mover COI, and full setup coordination.',
    mountingInstallation:
      'Six conference rooms needed TV and whiteboard installs. Codi sent a crew, ran cable, and had everything mounted in one day.'
  },
  officeAssistant: {
    demandLead: 'General office support',
    demandRest: '15 offices in this neighborhood leverage Codi daily office support'
  }
});
